<sponsor-image>
<a title="{props.company}" class="top-sponsor" href="{props.site_url}">
  <img src="{props.image_url}" class="top-sponsor-image">
</a>
</sponsor-image>